exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".generated-box[data-v-d13ab0bc]{border:1px solid #d2e9d4;background:#f5fff6;border-radius:6px;padding:12px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/vue-loader/lib??vue-loader-options!./src/views/activation/ActivationAdd.vue?vue&type=style&index=0&id=d13ab0bc&prod&scoped=true&lang=css&
// module id = 1426
// module chunks = 0